var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper-bg main-layout"},[_c('HeaderTitleSvg',{attrs:{"setTitle":_vm.titilesvg,"setHref":'profile',"showLogo":true}}),_c('div',{staticClass:"wrapper-main pt-2"},[_c('div',{staticClass:"detail",domProps:{"innerHTML":_vm._s(_vm.cookiePolicy)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }